(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('ObservedDataController', ObservedDataController);

    ObservedDataController.$inject = ['ObservedData'];

    function ObservedDataController(ObservedData) {

        var vm = this;

        vm.observedData = [];

        loadAll();

        function loadAll() {
            ObservedData.query(function(result) {
                vm.observedData = result;
                vm.searchQuery = null;
            });
        }
    }
})();
